"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _SwPage = _interopRequireDefault(require("@/views/common/SwPage"));
var _res = require("@/api/auth/res");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var typesOptions = [{
  key: 1,
  display_name: '菜单'
}, {
  key: 2,
  display_name: '子菜单'
}, {
  key: 3,
  display_name: '按钮'
}, {
  key: 15,
  display_name: '外部接口'
}];
var systemOptions = [{
  key: -1,
  display_name: '平台'
}, {
  key: 1,
  display_name: '用户'
}];
var typesKeyValue = typesOptions.reduce(function (acc, cur) {
  acc[cur.key] = cur.display_name;
  return acc;
}, {});
var systemKeyValue = systemOptions.reduce(function (acc, cur) {
  acc[cur.key] = cur.display_name;
  return acc;
}, {});
var _default = exports.default = {
  inject: ['reload'],
  //刷新
  name: 'resIndex',
  directives: {
    waves: _waves.default
  },
  components: {
    SwPage: _SwPage.default
  },
  filters: {
    typeFilter: function typeFilter(key) {
      return typesKeyValue[key];
    },
    systemFilter: function systemFilter(key) {
      return systemKeyValue[key];
    }
  },
  data: function data() {
    var _this = this;
    var checkCode = function checkCode(rule, value, callback) {
      // 为菜单或者子菜单时，router必须填写
      (0, _res.checkCodeExist)(value, _this.midData.resId).then(function (response) {
        var exist = response.extra.exist;
        if (exist) {
          callback(new Error('此code已存在!'));
        } else {
          callback();
        }
      });
    };
    var checkRouter = function checkRouter(rule, value, callback) {
      // 为菜单或者子菜单时，router必须填写
      if (_this.midData.type === 1 || _this.midData.type === 2) {
        if (value === '') {
          callback(new Error('请输入路由路径!'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      tableKey: 0,
      treeKeyId: 0,
      //树key 用户出刷新
      resTreeData: null,
      //资源树 - 顶级
      childResTree: null,
      //子节点
      lastRecode: null,
      //最后操作的节点
      currNode: null,
      //当前节点资源ID
      currNodeData: null,
      //当前属性的数据
      isGetList: false,
      //异步加载树 - 会同时触发 树的“load node-click”事件，这时存在右侧table不刷新 此字段解决此问题
      resTreeProp: {
        //树结构
        label: "name",
        children: 'children'
      },
      list: [],
      total: null,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        keywords: null,
        parentId: null
      },
      listThreeQuery: {
        page: 1,
        limit: 10,
        keywords: null
      },
      resTreeQuery: {
        //资源树
        parentId: null
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '新建'
      },
      isUpdate: false,
      typesOptions: typesOptions,
      systemOptions: systemOptions,
      midData: {
        type: '1',
        system: '-1',
        resId: null,
        name: null,
        code: null,
        perms: null,
        icon: null,
        parentId: null,
        routerPath: null
      },
      parentMenu: {
        name: null,
        code: null,
        type: null
      },
      rules: {
        name: [{
          required: true,
          message: '请填写名称',
          trigger: 'change'
        }],
        type: [{
          required: true,
          message: '请选择类型',
          trigger: 'blur'
        }],
        system: [{
          required: true,
          message: '请选择资源级别',
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: '请输入资源code',
          trigger: 'blur'
        }, {
          validator: checkCode,
          trigger: 'blur'
        }],
        routerPath: [{
          validator: checkRouter,
          trigger: 'blur'
        }]
      },
      title: '',
      dialogTableVisible: false,
      threeList: [],
      threeTotal: null
    };
  },
  created: function created() {
    this.getResTree();
    this.handleFilter();
  },
  methods: {
    refreshTree: function refreshTree() {
      this.currNode = null;
      this.resTreeQuery.parentId = null;
      this.listQuery.parentId = null;
      this.getResTree();
      this.reload();
    },
    getResTree: function getResTree() {
      var _this2 = this;
      (0, _res.dynamicTree)(this.resTreeQuery).then(function (response) {
        //顶级目录
        _this2.resTreeData = response.data.sysOrgResList;
      });
    },
    handleNodeClick: function handleNodeClick(data, node) {
      //点击node触发
      if (node.isLeaf) {
        //叶子节点
        this.currNode = data.resId;
      } else {
        //非叶子节点
        if (this.isGetList || this.currNode !== data.resId) {
          this.currNode = data.resId;
          //页码
          this.listQuery.page = 1;
          //父节点
          this.listQuery.parentId = this.currNode;
          this.getList(); //根据父节点获取子目录table
          this.isGetList = false;
        }
      }
      this.currNodeData = node.data;
    },
    getList: function getList() {
      var _this3 = this;
      this.listLoading = true;
      (0, _res.queryMenuResPage)(this.listQuery).then(function (response) {
        if (response) {
          _this3.list = response.records;
          _this3.total = response.total;
        }
        setTimeout(function () {
          _this3.listLoading = false;
        }, 0.5 * 1000);
      }, function () {
        setTimeout(function () {
          _this3.listLoading = false;
        }, 0.5 * 1000);
      });
    },
    retPage: function retPage() {
      //分页
      this.getList();
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    resetMidData: function resetMidData() {
      this.midData.type = 1;
      this.midData.system = -1;
      this.midData.resId = null;
      this.midData.name = null;
      this.midData.code = null;
      this.midData.perms = null;
      this.midData.icon = null;
      this.midData.parentId = null;
      this.midData.routerPath = null;
      this.parentMenu.code = null;
      this.parentMenu.name = null;
      this.parentMenu.type = null;
    },
    handleCreate: function handleCreate(param) {
      var _this4 = this;
      this.resetMidData();
      this.dialogFormVisible = true;
      this.isUpdate = false;
      this.dialogStatus = 'create';
      if (param !== null) {
        this.midData.parentId = param.resId;
        this.parentMenu.code = param.code;
        this.parentMenu.name = param.name;
        this.parentMenu.type = param.type;
      }
      this.$nextTick(function () {
        _this4.$refs['dataForm'].clearValidate();
      });
      if (param !== null) {
        if (param.type === 1) {
          this.midData.type = 2;
        } else if (param.type === 2) {
          this.midData.type = 3;
        }
        this.midData.system = param.system;
      }
    },
    createData: function createData() {
      var _this5 = this;
      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          console.log(_this5.midData);
          (0, _res.createRes)(_this5.midData).then(function () {
            _this5.dialogFormVisible = false;
            _this5.$notify({
              title: '成功',
              message: '创建成功',
              type: 'success',
              duration: 3000
            });
            _this5.getList();
          });
        }
      });
    },
    handleUpdate: function handleUpdate(row) {
      var _this6 = this;
      this.resetMidData();
      this.dialogFormVisible = true;
      this.dialogStatus = 'update';
      this.isUpdate = true;
      (0, _res.getResInfo)(row.resId).then(function (response) {
        _this6.midData = Object.assign({}, response.data); // copy obj
      });
      this.$nextTick(function () {
        _this6.$refs['dataForm'].clearValidate();
      });
    },
    updateData: function updateData() {
      var _this7 = this;
      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          var tempData = Object.assign({}, _this7.midData);
          (0, _res.updateRes)(tempData).then(function () {
            _this7.dialogFormVisible = false;
            _this7.isUpdate = false;
            _this7.$notify({
              title: '成功',
              message: '更新成功',
              type: 'success',
              duration: 3000
            });
            _this7.resetMidData(); //设置数据
            _this7.getList();
          });
        }
      });
    },
    handleDelete: function handleDelete(row) {
      var _this8 = this;
      this.$confirm('是否删除该记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _res.deleteRes)(row.resId).then(function () {
          _this8.$message({
            type: 'success',
            message: '删除成功!'
          });
          _this8.refreshTree();
        });
      }).catch(function () {
        _this8.$message({
          type: 'info',
          message: '已取消'
        });
      });
    }
  }
};